<template>
    <!--START SUBSCRIBE-->
        <section id="subscribe" class="section section-lg bg-subscribe">
            <div class="bg-overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2 text-center">
                        <h1 class="get-started-title text-white">Want to keep updated?</h1>
                        <div class="section-title-border margin-t-20 bg-white"></div>
                        <p class="section-subtitle font-secondary text-white text-center padding-t-30">
                            Subscribe to receive the latest updates!
                        </p>
                        <a class="btn btn-bg-white waves-effect margin-t-20 mb-4" data-toggle="modal" data-target="#subscriptionModal">
                            Subscribe <i class="mdi mdi-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="bg-pattern-effect">
                <img src="images/bg-pattern-light.png" alt="">
            </div>
        </section>
        <!--END SUBSCRIBE-->
</template>

<script>
    export default {
        name: 'Subscribe',
    }
</script>
